export default __webpack_public_path__ + "static/media/boldare_products_min.7ab2bf00.mp4";